import React, { useEffect } from 'react';
import Navbar from '../../components/00Global/02NavBar';
import Marquee from '../../components/00Global/01Marquee';
import Footer from '../../components/00Global/03Footer';

const OKampus = () => {
    useEffect(() => {
        document.title = 'OKAMPUS - Club Olesa Patí';
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-slate-900 flex flex-col">
            <div className='absolute z-50 w-full'>
                <Marquee />
                <Navbar />
            </div>

            <main className="flex-grow pt-32 lg:pt-48 pb-20 ">
                <div className="max-w-6xl mx-auto px-4">
                    <div className="flex flex-col items-center">
                        {/* Poster Image */}
                        <div className="mt-20 relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden mb-12 transform transition-transform hover:scale-[1.01]">
                            <img
                                src="/assets/okampus_poster.png"
                                alt="OKAMPUS Amposta Poster"
                                className="w-full h-auto"
                            />
                        </div>

                        {/* Registration Buttons */}
                        <div className="flex flex-col sm:flex-row gap-6 lg:gap-10">
                            <a
                                href="https://docs.google.com/forms/d/e/1FAIpQLSc--C3T-5APa7rcR4qU3kIExHUDRh9XmRMGsBS0RrgkTyx3VQ/viewform"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="px-10 py-4 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-emerald-600 hover:to-green-700 text-xl text-white font-bold drop-shadow-xl rounded-full transition-all hover:scale-105 text-center shadow-lg"
                            >
                                Inscripció socis
                            </a>
                            <a
                                href="https://docs.google.com/forms/d/e/1FAIpQLSefyNlxfWOju1YPYKGj0fB-V-H6h7hHF0-7YGZpy1GGr3-MLw/viewform?usp=send_form"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="px-10 py-4 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-indigo-600 hover:to-blue-700 text-xl text-white font-bold drop-shadow-xl rounded-full transition-all hover:scale-105 text-center shadow-lg"
                            >
                                Inscripció no socis
                            </a>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default OKampus;
